.root {
    max-width: 60rem;
}

.heading {
    color: var(--mantine-color-white);
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.01em;
    margin: 0;
}

.subtitle {
    color: var(--mantine-color-white);
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.4;
    max-width: 56rem;
}

.dismissButton {
    margin-top: 0.5rem;
}

.countdown {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    color: var(--mantine-color-dark-1);
    font-size: 0.8125rem;
    /* Tabular figures keep the digits from jiggling as the seconds tick. */
    font-variant-numeric: tabular-nums;
}

.countdownIcon {
    color: var(--mantine-color-dark-2);
}
